import { computed, observable } from 'mobx';
import Abstract from './abstract';
import _ from 'lodash';

const AI_TYPES = ['AI_INTERACTIVE_CLASS', 'AI_DOUBLE_TEACHER_CLASS'];

export class Course extends Abstract {
  @observable public filters;
  @computed get onlyPreparation() {
    const { permissions, modules } = alo7Account;
    return _.isEmpty(permissions) && modules.length === 1;
  }

  isAiCourse = (inType) => {
    return AI_TYPES.includes(inType);
  };

  isAi2TeacherClass = (inType) => {
    return inType === 'AI_DOUBLE_TEACHER_CLASS';
  };
}
